export default "__VITE_ASSET__KPY$YYpO__"